// extracted by mini-css-extract-plugin
module.exports = {"prompt":"IntroSwipePrompt-module--prompt--37ZvJ","show":"IntroSwipePrompt-module--show--31KpB","icon":"IntroSwipePrompt-module--icon--2g8Nt"};